var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.41418","width":"50.9946","height":"2","transform":"rotate(45 1.41418 0)","fill":"#FF8E15","key":0}),React.createElement("rect",{"x":"0.00012207","y":"70.7107","width":"50.9833","height":"2","transform":"rotate(-45 0.00012207 70.7107)","fill":"#FF8E15","key":1})]);
}

ChevronRight.defaultProps = {"width":"38","height":"73","viewBox":"0 0 38 73","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
